export default function getDisplayName(WrappedComponent) {
  try {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  } catch (e) {
    console.error('Could not get display name of component', WrappedComponent);
  }
}
